<div class="m-3">
  <i class="bi bi-exclamation-triangle ui-confirmdialog-icon"></i>
  <span class="ui-confirmdialog-message"> {{ config.data.message }} </span>
</div>
<div class="ui-dialog-footer">
  <button type="button" pButton icon="pi pi-times" [label]="'global.no' | translate" (click)="reject()"></button>
  <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'global.yes' | translate" (click)="accept()"></button>
</div>
